import { EntityModel, EntityInvitationModel } from "@jugl-web/rest-api";
import { createContext } from "react";

export interface EntitiesListContextValue {
  entitiesState: {
    isLoading: boolean;
    isError: boolean;
    isFetching: boolean;
    entities?: EntityModel[] | undefined;
  };
  entityInvitesState: {
    isLoading: boolean;
    isError: boolean;
    isFetching: boolean;
    entityInvites?: EntityInvitationModel[] | undefined;
  };
  refetchEntities: () => Promise<void>;
  refetchEntityInvites: () => Promise<void>;
}

export const EntitiesListContext =
  createContext<EntitiesListContextValue | null>(null);
